import { FunctionComponent } from 'react';

import FaqSearch from 'components/modules/public/layout/forms/FaqSearchForm';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageFaqSectionSearch: FunctionComponent<Props> = ({ onSuccess, initialValues, ...form }) => {
    return (
        <StyledComponent
            className="public-page-faq-section-search"
        >
            <FaqSearch
                {...form}
                onSuccess={onSuccess}
                initialValues={initialValues}
            />
        </StyledComponent>
    );
};

export default PublicPageFaqSectionSearch;